// BUG-008: the Admin user lists show when someone's sign-in is paused by the SEC-007 lockout.
// `paused_until` comes from the server (the latest pause on any address, or null). Plain CommonJS so the backend
// test run can test it directly, like utils/mtdScope.js.

// Still paused right now? (A page left open past the end of the pause stops showing it without a refresh.)
function isPaused(user, now = new Date()) {
  if (!user || !user.paused_until) return false;
  const until = new Date(user.paused_until);
  return !Number.isNaN(until.getTime()) && until > now;
}

// "14:05" in UK time, for the badge
function pausedUntilLabel(user) {
  if (!user || !user.paused_until) return '';
  const until = new Date(user.paused_until);
  if (Number.isNaN(until.getTime())) return '';
  return until.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/London' });
}

module.exports = { isPaused, pausedUntilLabel };
